export default "https://cdn-static.gokick.com/assets/faf4ec4796b5499b7477edf17656e3681d9dd642/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";